// extracted by mini-css-extract-plugin
export var container = "_7b-0";
export var icon = "_7b-1";
export var text = "_7b-2";